import React, { useRef } from "react";
import { Button } from 'react-bootstrap';
import { FaChevronDown } from "react-icons/fa";
import ProductUsageGraph from 'pages/dashboard/components/ProductUsageGraph';
import ProductUsageTable from 'pages/dashboard/components/ProductUsageTable';
import DateRangePicker from "common/components/DateRangePicker";
import UsageGraph from 'pages/dashboard/components/UsageGraph';
import { useSuperState } from "helpers/hooks";
import { FormattedDateTimeRange } from "react-intl";
import moment from "moment";

export const HistoricalUsage = () => {

    const [state, setState] = useSuperState({
        start_date: moment().subtract(1, 'month').toDate().getTime(),
        end_date: moment().toDate().getTime(),
        appstream_fleet_name: null
    });

    const datepicker = useRef();

    const { start_date, end_date, appstream_fleet_name } = state;

    const handleClick = () => {

        const picker = datepicker?.current;
        if (!picker) return;

        picker.show({ start_date, end_date });
    };

    const handleSelect = ({ start_date, end_date }) => setState({ start_date, end_date });

    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-2">
                <h3 className="text-secondary">
                    Historical Usage
                </h3>
                <Button variant="secondary" onClick={handleClick}>
                    <FormattedDateTimeRange
                        from={start_date}
                        to={end_date}
                    />
                    <FaChevronDown className="ms-2" />
                </Button>
            </div>

            <ProductUsageTable
                appstream_fleet_name={appstream_fleet_name}
                start_date={start_date}
                end_date={end_date}
                className="mb-3"
            />

            <UsageGraph
                appstream_fleet_name={appstream_fleet_name}
                start_date={start_date}
                end_date={end_date}
                className="mb-3"
            />

            <ProductUsageGraph
                appstream_fleet_name={appstream_fleet_name}
                start_date={start_date}
                end_date={end_date}
            />

            <DateRangePicker
                onRef={el => datepicker.current = el}
                onSelect={handleSelect}
            />
        </>
    );

};